import React, { useEffect, useState } from 'react'
import { Avatar, Form, Input, InputNumber, Modal, notification, Select, Table } from 'antd'
import withPackageDamagedReasons from '../../../hocs/withPackageDamagedReasons'
import { withTranslation } from 'react-i18next'
import { getVar } from '../../../system/support/helpers'
import apiService from '../apiService'
import { get } from 'lodash'
import { ProductImage } from '../../Common/components/ProductImage'
function DefectivePackageInformation(props) {
    const { visible, handleCancel, handleOk, products, packageDamagedReasons, loadingPackageDamagedReasons, packageId, t, form } = props
    const { getFieldDecorator } = form
    const [dataSource, setDataSource] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        const dataSource = []
        const initialValues = {}
        const productErrors = JSON.parse(localStorage.getItem('productErrors_' + packageId) || '[]')
        productErrors.forEach((data, index) => {
            dataSource.push(data)
            initialValues[`package_item_issues[${index}].id_package_item`] = data.id
            initialValues[`package_item_issues[${index}].issue_type`] = getVar(data, 'issue_type')
            initialValues[`package_item_issues[${index}].quantity`] = getVar(data, 'quantity')
            initialValues[`package_item_issues[${index}].description`] = getVar(data, 'description')
        })

        setDataSource(dataSource)
        form.setFieldsValue(initialValues)
    }, [products])

    const updateField = (index, key, value) => {
        if (key === 'quantity') {
            const parsed = parseInt(value)
            value = isNaN(parsed) ? null : parsed
        }
        const updated = [...dataSource]
        form.setFieldsValue({ [`package_item_issues[${index}].${key}`]: value })
        updated[index][key] = value
        setDataSource(updated)
    }

    const handleOkModal = () => {
        form.validateFields((error, values) => {
            if (error) {
                return
            }
            setLoading(true)
            apiService
                .updateProductIssuesInformation(packageId, values)
                .then(() => {
                    notification.success({ message: 'Cập nhật thông tin lỗi cho sản phẩm thành công!' })
                    setTimeout(() => {
                        localStorage.removeItem('productErrors_' + packageId)
                        handleOk()
                    }, 3000)
                    form.resetFields()
                })
                .catch(e => {
                    notification.error({ message: 'Cập nhật thông tin lỗi cho sản phẩm thất bại!' })
                })
                .finally(() => {
                    handleCancel()
                    setLoading(false)
                })
        })
    }

    const handleCancelModal = () => {
        handleCancel()
    }

    const columns = [
        {
            title: t('package:label.product'),
            dataIndex: 'name',
            key: 'name',
            width: '300px',
            render: (text, record, index) => {
                return (
                    <div className="gflex galign-center gjustify-space-between">
                        <ProductImage imageUrl={record.imageUrl} size={40} />
                        <a
                            className="a-item-package--link"
                            href={record.url}
                            rel="noopener noreferrer"
                            target="_blank">
                            {text}
                            <Form.Item style={{ display: 'none' }}>
                                {getFieldDecorator(`package_item_issues[${index}].id_package_item`, {
                                    initialValue: record.id,
                                })(<Input />)}
                            </Form.Item>
                        </a>
                    </div>
                )
            },
        },
        {
            title: (
                <div>
                    {t('package:package_issue.label.damage_reason')}
                    <span className="a-text--red"> (*)</span>
                </div>
            ),
            dataIndex: 'issue_type',
            key: 'issue_type',
            render: (text, record, index) => {
                return (
                    <Form.Item className="mb-0">
                        {getFieldDecorator(`package_item_issues[${index}].issue_type`, {
                            rules: [
                                {
                                    required: true,
                                    message: t('validation:required', {
                                        attribute: t('package:package_issue.label.damage_reason'),
                                    }),
                                },
                            ],
                        })(
                            <Select
                                allowClear
                                className="_damaged-reasons width-100-pc"
                                dropdownClassName="_dropdown-damaged-reasons"
                                loading={loadingPackageDamagedReasons}
                                optionFilterProp="children"
                                placeholder={'Vui lòng chọn lý do sai/lỗi'}
                                onChange={value => {
                                    updateField(index, 'issue_type', value)
                                }}>
                                {packageDamagedReasons.map(damagedReason => (
                                    <Select.Option
                                        className="_damage-reason-item"
                                        key={damagedReason.code}
                                        value={damagedReason.code}>
                                        {damagedReason.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                )
            },
        },

        {
            title: (
                <div>
                    {t('package:package_issue.label.quantity')}
                    <span className="a-text--red"> (*)</span>
                </div>
            ),
            dataIndex: 'quantity',
            key: 'quantity',
            render: (text, record, index) => {
                return (
                    <Form.Item className="mb-0">
                        {getFieldDecorator(`package_item_issues[${index}].quantity`, {
                            rules: [
                                {
                                    required: true,
                                    message: t('validation:required', {
                                        attribute: t('package:package_issue.label.quantity'),
                                    }),
                                },
                                {
                                    type: 'number',
                                    min: 1,
                                    message: t('validation:min.numeric', {
                                        attribute: t('package:package_issue.label.quantity'),
                                        min: 1,
                                    }),
                                },
                            ],
                        })(
                            <InputNumber
                                min={1}
                                placeholder={t('package:package_issue.placeholder.quantity')}
                                onChange={value => updateField(index, 'quantity', value)}
                                style={{ width: '100%' }}
                            />
                        )}
                    </Form.Item>
                )
            },
        },
        {
            title: <div>{t('package:package_issue.label.description')}</div>,
            dataIndex: 'description',
            key: 'description',
            render: (text, record, index) => {
                return (
                    <Form.Item className="mb-0">
                        {getFieldDecorator(`package_item_issues[${index}].description`)(
                            <Input.TextArea
                                placeholder={t('package:package_issue.placeholder.description')}
                                onChange={e => updateField(index, 'description', e.target.value)}
                                autoSize={{ minRows: 3, maxRows: 5 }}
                            />
                        )}
                    </Form.Item>
                )
            },
        },
    ]

    return (
        <Modal
            width="70%"
            title={t('package:package_issue.title')}
            visible={visible}
            cancelText={t('btn.cancel')}
            okText={t('btn.ok')}
            onOk={handleOkModal}
            onCancel={handleCancelModal}
            okButtonProps={{ loading }}>
            <Form>
                <Table
                    rowKey={record => record.id}
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                />
            </Form>
        </Modal>
    )
}

export default withTranslation()(
    withPackageDamagedReasons(Form.create()(DefectivePackageInformation), {
        getDataWhenMounted: true,
    })
)
